import "./styles/Skeleton.scss";

export const GifPreviewPlaceholder = () => <div className="GifPreviewPlaceholder" />;
export const GifTilePlaceholder = ({ isVertical }: { isVertical?: boolean }) => <div className={`GifTile ${isVertical ? "GifTile_isVertical" : ""}`} />;
export const GifBlockPlaceholder = () => <div className="tile GifBlockPlaceholder" />;
export const NicheBlockPlaceholder = () => <div className="NichePreview NicheBlockPlaceholder" />;
export const TrendingTagsPlaceholder = () => <div className="seeMoreBlock trendingTags trendingTagsPlaceholder" />;
export const CreatorTilePlaceholder = () => <div className="CreatorTile CreatorTilePlaceholder" />;
export const TagPlaceholder = () => <div className="TagPlaceholder" />;
